import { render, staticRenderFns } from "./languages.vue?vue&type=template&id=4dacbedc&"
import script from "./languages.vue?vue&type=script&lang=js&"
export * from "./languages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports